import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import AdminModal from './AdminModal';
import AdminForm from './AdminForm';
import { useUpdateAdmin } from '../../hooks/useAdmins';

const EditAdmin = ({ isOpen, onClose, selectedAdmin }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    image: null
  });

  const updateAdminMutation = useUpdateAdmin();

  // Update form data when selectedAdmin changes
  useEffect(() => {
    if (selectedAdmin) {
      setFormData({
        name: selectedAdmin.name || '',
        email: selectedAdmin.email || '',
        password: '',
        image: null // Reset image input for edit
      });
    }
  }, [selectedAdmin]);

  const handleFormChange = (e) => {
    const { name, value, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    try {
      await updateAdminMutation.mutateAsync({
        id: selectedAdmin.id,
        adminData: formData
      });
      onClose();
      setFormData({ name: '', email: '', password: '', image: null });
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Admin updated successfully!',
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error('Error updating admin:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Failed to update admin',
        confirmButtonText: 'OK',
        background: '#ffffff',
        color: '#333',
        customClass: {
          popup: 'rounded-lg shadow-xl',
          confirmButton: 'bg-[#dc2626] text-white font-bold py-2 px-4 rounded',
          cancelButton: 'bg-[#6b7280] text-white font-bold py-2 px-4 rounded',
        }
      });
    }
  };

  const handleCancel = () => {
    setFormData({ name: '', email: '', password: '', image: null });
    onClose();
  };

  return (
    <AdminModal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit Admin"
    >
      <AdminForm 
        formData={formData}
        onFormChange={handleFormChange}
        onSubmit={handleFormSubmit}
        isEdit={true}
        isMutating={updateAdminMutation.isPending}
        selectedAdmin={selectedAdmin}
        onCancel={handleCancel}
      />
    </AdminModal>
  );
};

export default EditAdmin; 